module.exports = __webpack_public_path__ + "00c5b662988770a0343078c83bbe7daa.png";


//////////////////
// WEBPACK FOOTER
// ./photo.png
// module id = 492
// module chunks = 0